module.exports = __webpack_public_path__ + "img/cluster-28-advert-square.d4393cad.svg";